import {
  FORGET_PASSWORD,
  FORGET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_ERROR,
  CLEAR_FORGET_PASSWORD,
} from "./actionTypes"

const initialState = {
  forgetSuccessMsg: null,
  forgetError: null,
  loading: false,
}

const forgetPassword = (state = initialState, action) => {
  switch (action.type) {
    case FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        loading: true,
      }
      break
    case FORGET_PASSWORD_SUCCESS:
      state = {
        ...state,
        forgetSuccessMsg: action.payload,
        loading: false,
      }
      break
    case FORGET_PASSWORD_ERROR:
      state = { ...state, forgetError: action.payload, loading: false }
      break
    case CLEAR_FORGET_PASSWORD:
      state = {
        ...state,
        forgetSuccessMsg: null,
        forgetError: null,
        loading: false,
      }
      break
    case "RESET_FORGET_PASSWORD":
      state = {
        ...state,
        resetSuccessMsg: null,
        resetError: null,
      }
      break
    case "RESET_FORGET_PASSWORD_SUCCESS":
      state = {
        ...state,
        resetSuccessMsg: action.payload,
      }
      break
    case "RESET_FORGET_PASSWORD_ERROR":
      state = {
        ...state,
        resetError: action.payload,
      }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default forgetPassword
